import { useEffect, useState } from 'react';
import { countdownTimer } from 'helpers/index';

const useCountdownTimer = (milliSecond) => {
  const [time, setTime] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    let time = milliSecond;

    const getTime = () => {
      setTime(countdownTimer(time));
      time -= 1000;
    };

    const id = setInterval(getTime, 1000);

    return () => {
      clearInterval(id);
    };
  }, [milliSecond]);

  return time;
};

export default useCountdownTimer;
